module.exports = __webpack_public_path__ + "static/media/has-notification.2707d85c.svg";